import { useContext } from "react";
import { CheckboxProps as AriaCheckboxProps } from "react-aria-components";

import { _Checkbox } from "./assets/_Checkbox";
import { CheckboxGroupRACContext } from "./checkbox-group/CheckboxGroupRAC";
import { Stack } from "../../../foundations/grid-layout/Stack";
import { _Text } from "../../_assets/_Text";
import {
  FieldErrorsProps,
  FieldErrors,
} from "../_assets/input-wrapper/FieldErrors";

export interface CheckboxProps extends Omit<AriaCheckboxProps, "style"> {
  children: string | React.ReactNode;
  errors?: FieldErrorsProps["children"];
  description?: string;
  testID: string;
  isCard?: boolean;
  noBorder?: boolean;
  style?: "default" | "subtle";
}

export function CheckboxRAC(props: CheckboxProps) {
  const {
    errors,
    children,
    description,
    style: textStyle = "default",
    isCard,
    testID,
    noBorder,
    ...checkboxProps
  } = props;
  const { isGroup, isCard: groupIsCard } = useContext(CheckboxGroupRACContext);

  return (
    <Stack gap="space-1">
      <_Checkbox
        noBorder={noBorder}
        {...checkboxProps}
        isCard={isCard || groupIsCard}
        data-testid={`${testID}-checkbox`}
      >
        <_Text
          style={textStyle === "subtle" ? "form/body-secondary" : "input/label"}
        >
          {children}
        </_Text>
        {description && (
          <_Text style="input/helper" color="text-weak" slot="description">
            {props.description}
          </_Text>
        )}
      </_Checkbox>
      {!isGroup && <FieldErrors>{errors}</FieldErrors>}
    </Stack>
  );
}
